import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  class: "jl2-custom-filled-icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z",
      stroke: "currentColor",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.7778 13.8333H11.8333V9.66667H18.5V12.1667C18.5 12.6222 18.8778 13 19.3333 13H21.8333M10.1667 19.6667V15.5H11.4111C12.1 15.5 12.6556 16.0556 12.6556 16.7444C12.6556 17.4333 12.1 17.9889 11.4111 17.9889H10.1667M17.6667 19.6556V15.4889H20.1667M17.6667 17.1556H19.8333M11.8333 21.3222H21.8333M11.8333 8C10.9222 8 10.1667 8.75556 10.1667 9.66667V13.8333C9.24444 13.8333 8.5 14.5778 8.5 15.5V19.6667C8.5 20.5889 9.24444 21.3333 10.1667 21.3333V23C10.1667 23.9111 10.9222 24.6667 11.8333 24.6667H21.8333C22.7444 24.6667 23.5 23.9111 23.5 23V12.5111C23.5 12.2889 23.4111 12.0778 23.2556 11.9222L19.5778 8.24444C19.4222 8.08889 19.2111 8 18.9889 8H11.8333ZM13.7556 15.4889V19.2667H14.5333C15.3333 19.2667 16.2889 19.0222 16.2889 17.8667V16.8889C16.2889 15.7222 15.3444 15.4889 14.5444 15.4889H13.7444H13.7556Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "stroke-content"
    }, null, -1)
  ])))
}